import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import { fetchStrech }      from "Actions/Admin/Strech/StrechActions";
import Action               from "dashboard/dist/Core/Action";
import Utils                from "dashboard/dist/Utils/Utils";
import StrechStep           from "Utils/Entity/StrechStep";

// Sections
import PriceEdit            from "./PriceEdit";
import StrechBar            from "Components/Admin/Strech/Strech/StrechBar";

// Components
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";
import DeleteDialog         from "dashboard/dist/Components/DeleteDialog";
import ConfirmDialog        from "dashboard/dist/Components/ConfirmDialog";

// Actions
import {
    fetchPrices, deletePrice, importPrices,
} from "Actions/Admin/Strech/PriceActions";



/**
 * The Strech Price List
 */
class PriceList extends React.Component {
    // The Current State
    state = {
        action : Action.get(),
        elemID : 0,
    }

    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch();
    }

    /**
     * Fetch the content
     * @param {Object=} params
     * @returns {Void}
     */
    fetch = (params) => {
        const { type, elemID, data } = this.props;
        this.props.fetchPrices(type, elemID, params || data.sort);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        this.setState({ action, elemID });
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }



    /**
     * Handles the Edit Submit
     * @returns {Void}
     */
    editElem = () => {
        this.endAction();
        this.fetch();
        this.props.fetchStrech(this.props.elemID);
    }

    /**
     * Handles the Delete Submit
     * @returns {Promise}
     */
    deleteElem = async () => {
        await this.props.deletePrice(this.state.elemID);
        this.editElem();
    }

    /**
     * Handles the Import Submit
     * @returns {Promise}
     */
    importElem = async () => {
        const strechID = this.props.params.strechID;
        await this.props.importPrices(strechID);
        this.editElem();
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { action, elemID                           } = this.state;
        const { data, strech, params, route, withDetails } = this.props;
        const { canEdit, list, total, sort, loading      } = data;

        const elemName = Utils.getValue(list, "strechPriceID", elemID, "name");

        return <Main withDetails={withDetails}>
            <Header message="PRICES_NAME" icon="price" route={route}>
                <ActionList data={data} onAction={this.startAction} />
            </Header>
            <Content isLoading={loading}>
                <StrechBar step={StrechStep.PRICES} />
                <Table
                    fetch={this.fetch}
                    sort={sort}
                    none="PRICES_NONE_AVAILABLE"
                    hasAlert={StrechStep.hasHelp(strech, StrechStep.PRICES)}
                >
                    <TableHead>
                        <TableHeader field="dues"         message="PRICES_DUES"       />
                        <TableHeader field="price"        message="GENERAL_PRICE"     />
                        <TableHeader field="showPrice"    message="PRICES_SHOW_SHORT" maxWidth="80"  align="center" />
                        <TableHeader field="promotionEnd" message="PRICES_PROMOTION"  maxWidth="160" align="center" />
                        <TableHeader field="createdTime"  message="GENERAL_CREATED"   maxWidth="90"  hideMobile />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.strechPriceID} elemID={elem.strechPriceID}>
                            <TableCell message={elem.duesName}        circle={elem.statusColor} />
                            <TableCell message={`$ ${elem.price}`}    />
                            <TableCell message={elem.showPriceString} />
                            <TableCell message={elem.promotionString} />
                            <TableCell message={elem.createdDate}     />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="EDIT"   message="PRICES_EDIT_TITLE"   />
                        <TableAction action="DELETE" message="PRICES_DELETE_TITLE" />
                    </TableActionList>
                </Table>
            </Content>

            <PriceEdit
                open={action.isVCE}
                elemID={elemID}
                strechID={params.strechID}
                onSubmit={this.editElem}
                onClose={this.endAction}
            />
            <DeleteDialog
                open={action.isDelete}
                title="PRICES_DELETE_TITLE"
                message="PRICES_DELETE_TEXT"
                content={elemName}
                onSubmit={this.deleteElem}
                onClose={this.endAction}
            />
            <ConfirmDialog
                open={action.isImport}
                icon="import"
                title="PRICES_IMPORT_TITLE"
                message="PRICES_IMPORT_TEXT"
                onSubmit={this.importElem}
                onClose={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchStrech  : PropTypes.func.isRequired,
        fetchPrices  : PropTypes.func.isRequired,
        deletePrice  : PropTypes.func.isRequired,
        importPrices : PropTypes.func.isRequired,
        data         : PropTypes.object.isRequired,
        strech       : PropTypes.object.isRequired,
        type         : PropTypes.string.isRequired,
        params       : PropTypes.object.isRequired,
        route        : PropTypes.string.isRequired,
        withDetails  : PropTypes.bool.isRequired,
        elemID       : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data   : state.strechPrice,
            strech : state.strech.elem,
        };
    }
}

export default connect(PriceList.mapStateToProps, {
    fetchStrech, fetchPrices, deletePrice, importPrices,
})(PriceList);
